import Cookies from 'js-cookie';
import { decrypt, encrypt } from './xorEncryption';

export const setCookie = (key: string, value: string) => {
    try {
        const encryptedValue = encrypt(value); // returns a string
        Cookies.set(key, encryptedValue, {
            path: '/',
            secure: true,
            sameSite: 'Lax',
        });
    } catch (err) {
        console.error(`Error setting cookie [${key}]:`, err);
    }
};

export const getCookie = (key: string) => {
    try {
        const encryptedValue = Cookies.get(key);
        return encryptedValue ? (decrypt(encryptedValue)) : null;
    } catch (err) {
        console.error(`Error getting cookie [${key}]:`, err);
        return null;
    }
};

export const removeCookie = (key: string) => {
    try {
        Cookies.remove(key, { path: '/' });
    } catch (err) {
        console.error(`Error removing cookie [${key}]:`, err);
    }
};